<div class="route-results-container">
    <app-route-results-header [routeFormResults]="routeFormResults" ></app-route-results-header>
    <app-route-results-options [routeFormResults]="routeFormResults" [optionSelected]="routeResultOptionSelected" ></app-route-results-options>
</div>